export const BUILDER_STUDIO_DESKTOP_MEDIA_QUERY = "(min-width: 768px)";

type BuilderStudioMediaQueryMatcher = (
  query: string,
) => Pick<MediaQueryList, "matches">;

/**
 * The desktop editor has enough room to expose its inspector immediately.
 * Narrow viewports keep the existing collapsed sheet until the user opens it.
 */
export function builderInspectorCollapsedWhenEnteringEdit(
  matchMedia?: BuilderStudioMediaQueryMatcher,
): boolean {
  return !(matchMedia?.(BUILDER_STUDIO_DESKTOP_MEDIA_QUERY).matches ?? false);
}
